/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCountryState,
    MelcoModelsCountryStateFromJSON,
    MelcoModelsCountryStateFromJSONTyped,
    MelcoModelsCountryStateToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsCountryState
 */
export interface MelcoModelsGenericList1MelcoModelsCountryState {
    /**
     * 
     * @type {Array<MelcoModelsCountryState>}
     * @memberof MelcoModelsGenericList1MelcoModelsCountryState
     */
    list: Array<MelcoModelsCountryState>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsCountryState
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsCountryState
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsCountryStateFromJSON(json: any): MelcoModelsGenericList1MelcoModelsCountryState {
    return MelcoModelsGenericList1MelcoModelsCountryStateFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsCountryStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsCountryState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsCountryStateFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsCountryStateToJSON(value?: MelcoModelsGenericList1MelcoModelsCountryState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsCountryStateToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


